import React, { useEffect, useState } from 'react';
import {  useDispatch, useSelector } from 'react-redux';
import {  useHistory } from 'react-router-dom';
import { Table } from 'reactstrap';
import { Form, Formik } from 'formik';
import Layout from 'web/components/Layout';
import MultiSelect from 'web/components/form-elements/MultiSelect';
import {
    INITIAL_VALUES,
    VALIDATION_SCHEMA,
} from 'web/components/utils/groupsUtils';
import {
    sellerList,
    createGroup,
    buyerList,
    groupListApi,
    sellerGroupListApi,
    createSellerGroup,
    groupActive,
    sellerActive,
} from 'redux/actions/addGroup';

import Button from 'web/components/Button';
import Spinner from 'web/components/Spinner';
import EditGroup from 'web/components/EditGroup';
import AlertModal from 'web/components/AlertModal';
import TextInput from 'web/components/form-elements/TextInput';
import DeleteModal from 'web/components/DeleteModal';

import styles from './groups.module.scss';

const Groups = () => {
    const dispatch = useDispatch();
    let history = useHistory();
    const [hideShow, setHideShow] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);
    let title = '';
    const token = localStorage.getItem('token');

    const [editModal, setEditModal] = useState(false);
    const toggleEditModal = () => setEditModal(!editModal);

    const [deleteModal, setDeleteModal] = useState(false);
    const [modalDeleteLink, setModalDeleteLink] = useState('/');
    const toggleDeletModal = () => setDeleteModal(!deleteModal);

    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );
    const dropDownArr = [
        {
            label: '',
            value: '',
        },
    ];
    const [dropDownList, setDropDownList] = useState(dropDownArr);
    const [selected, setSelected] = useState([]);
    const userType = localStorage.getItem('userType');
    const [resultGroup, setGroupResponse] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMyAPI = async () => {
        let response = '';
        if (userType === 'Buyer') {
            response = await dispatch(sellerList(token));
        } else {
            response = await dispatch(buyerList(token));
        }
        if (token === null) {
            setModalContent('Please Sign In again.');
            setModalLink('/sign-in');
            toggleModal();
        } else {
            if (response.status === 'SUCCESS') {
                if (response.payload.length !== 0) {
                    const dropDownArr = [];
                    for (let i = 0; i < response.payload.length; i++) {
                        let obj = {
                            label: response.payload[i].basicDetail.companyName,
                            value: response.payload[i].id,
                        };
                        dropDownArr.push(obj);
                    }
                    setDropDownList(dropDownArr);
                }
                groupListApiFun();
            } else {
                if (response.message === "Unauthorized (Invalid token)") {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(response.message);
                    setModalLink('');
                    toggleModal();
                }
            }
        }
    };
    const groupListApiFun = async () => {
        let groupListResponse = '';
        if (userType === 'Buyer') {
            groupListResponse = await dispatch(groupListApi(token));
        } else {
            groupListResponse = await dispatch(sellerGroupListApi(token));
        }
        if (groupListResponse.status === 'SUCCESS') {
            if (groupListResponse.payload.length !== 0) {
                setGroupResponse(groupListResponse.payload);
            }
        }
    };
    useEffect(() => {
        if (!localStorage.getItem('token')) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
            fetchMyAPI();
        }
    }, []);
    const [isOpen, toggle] = useState(false);
    const handleAddGroup = async (props) => {
        const { setFieldValue, resetForm } = props;
        let sellerIdArr = [];
        let response = '';
        if (userType === 'Buyer') {
            for (let i = 0; i < props.values.seller.length; i++) {
                let obj = {
                    sellerId: props.values.seller[i].value,
                };
                sellerIdArr.push(obj);
            }

            let data = {
                groupName: props.values.groupName,
                seller: sellerIdArr,
            };
            response = await dispatch(createGroup(data, token));
        } else {
            for (let i = 0; i < props.values.seller.length; i++) {
                let obj = {
                    buyerId: props.values.seller[i].value,
                };
                sellerIdArr.push(obj);
            }

            let data = {
                groupName: props.values.groupName,
                buyer: sellerIdArr,
            };
            response = await dispatch(createSellerGroup(data, token));
        }

        if (response.status === 'SUCCESS') {
            setMultiSelectVal([])
            resetForm({ values: '' })
            fetchMyAPI();
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }
    };

    const [editGroupState, setEditGroupState] = useState({ id: '', name: '', groups: [] });
    const editFun = async (event, index, setFieldValue) => {
        let arr = [];
        if (userType === 'Buyer') {
            if (resultGroup[index].sellerInfo !== undefined) {
                for (let i = 0; i < resultGroup[index].sellerInfo.length; i++) {
                    let obj = {
                        value: resultGroup[index].sellerInfo[i].idInfo,
                        label: resultGroup[index].sellerInfo[i].name
                    }
                    arr.push(obj)
                    if (i === resultGroup[index].sellerInfo.length - 1)
                        setEditGroupState({ id: resultGroup[index].id, name: resultGroup[index].groupName, groups: arr })
                }
            }
        } else {
            if (resultGroup[index].buyerInfo !== undefined) {
                for (let i = 0; i < resultGroup[index].buyerInfo.length; i++) {
                    let obj = {
                        value: resultGroup[index].buyerInfo[i].idInfo,
                        label: resultGroup[index].buyerInfo[i].name
                    }
                    arr.push(obj)
                    if (i === resultGroup[index].buyerInfo.length - 1)
                        setEditGroupState({ id: resultGroup[index].id, name: resultGroup[index].groupName, groups: arr })
                }
            }
        }

        toggleEditModal()
    };

    const [indexVal, setIndex] = useState(0);
    const deleteFun = async (event, index) => {
        setIndex(index);
        toggleDeletModal();
    };
    const deleteGroupFun = async (val) => {
        toggleDeletModal()
        let response = '';
        let data = {
            id: resultGroup[indexVal].id,
            active: false,
        };
        if (userType === 'Buyer') {
            response = await dispatch(groupActive(data, token));

        } else {
            response = await dispatch(sellerActive(data, token));
        }
        if (response.status === "SUCCESS") {
            fetchMyAPI();
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }
    }
    const groupList = (setFieldValue) => {
        return (
            <div className={styles.groupList}>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>My Groups</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultGroup.length !== 0}
                        {resultGroup.map((item, index) => (
                            <tr key={index}>
                                <td>{resultGroup[index].groupName}</td>
                                <td className={styles.actionBtn}>
                                    <span className={styles.edit} onClick={(event) => {
                                        editFun(event, index, setFieldValue);
                                    }}>View</span>
                                    <span className={styles.dlt} onClick={(event) => {
                                        deleteFun(event, index, setFieldValue);
                                    }}>Delete</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };
    const [multiSelectVal, setMultiSelectVal] = useState([]);
    const multiSelectFun = () => {
        return (
            <div>
                {userType === 'Buyer' ? (
                    <MultiSelect
                        name='seller'
                        data={dropDownList}
                        multiSelectVal={multiSelectVal}
                        setMultiSelectVal={setMultiSelectVal}
                        defaultValueArr={[]}
                        placeholder='Add Sellers&#42;'
                    />) : (
                        <MultiSelect
                            name='seller'
                            data={dropDownList}
                            multiSelectVal={multiSelectVal}
                            setMultiSelectVal={setMultiSelectVal}
                            defaultValueArr={[]}
                            placeholder='Add Buyer&#42;'
                        />)
                }
            </div>
        )
    }
    return (
        <Layout transparentHeader={false} userType={userType} topBarViewMobile={"hide"}>
            <div className={styles.groupsContainer}>
                {loaderVisible && <Spinner />}
                <div className={styles.heading}>
                    <div></div>
                    <h3>My Group</h3>
                    <div></div>
                </div>
                <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={VALIDATION_SCHEMA}
                    onSubmit={(values) => { }}>
                    {(props) => {
                        const { isValid, dirty, values, errors, touched, setFieldValue } = props;
                        return (
                            <>
                                <Form
                                    className={hideShow === false ? styles.hide : styles.show}>
                                    <div className={styles.section}>
                                        <div className='row mx-0'>
                                            <div className='col-12'>
                                                <div className='my-2'>
                                                    <p>Group Name *</p>
                                                </div>
                                                <div>
                                                    <TextInput
                                                        name='groupName'
                                                        inputType="text"
                                                        placeholder='Group Name*'
                                                        showErrorMessages={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mx-0'>
                                            <div className='col-12'>
                                                <div className='my-2'>
                                                    {userType === 'Buyer' ? (<p>Add Sellers *</p>) : (<p>Add Buyers *</p>)}
                                                </div>
                                                {multiSelectFun()}
                                            </div>
                                        </div>
                                        <div className='row mx-0'>
                                            <div className='col-12'>
                                                <div className={styles.btnSection} >
                                                    <Button
                                                        type='app-green-button'
                                                        name="createGroup"
                                                        handleClick={() => {
                                                            handleAddGroup(props);
                                                        }}
                                                        disabled={!(isValid && dirty)}>
                                                        CREATE A GROUP
                                                </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                                <div>{groupList(setFieldValue)}</div>
                            </>
                        );
                    }}
                </Formik>
                <EditGroup
                    isOpen={editModal}
                    toggle={toggleEditModal}
                    editGroupState={editGroupState}
                    dropDownList={dropDownList}
                    title="My Group"
                    editHandler={() => { fetchMyAPI() }}
                    link="/"
                />
                <AlertModal
                    isOpen={modal}
                    toggle={toggleModal}
                    title={title}
                    content={modalContent}
                    link={modalLink}
                />
                <DeleteModal
                    isOpen={deleteModal}
                    toggle={toggleDeletModal}
                    onChangeHandler={(val) => {
                        deleteGroupFun(val)
                    }}
                    link={setModalDeleteLink}
                />
            </div>
        </Layout>
    );
};

export default Groups;
